var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueFunnel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28809 3.75H16.7124C16.8335 3.75 16.952 3.78517 17.0534 3.85124C17.1549 3.9173 17.235 4.01142 17.284 4.12215C17.333 4.23288 17.3487 4.35546 17.3293 4.47498C17.31 4.5945 17.2563 4.70583 17.1749 4.79542L12.0378 10.4462C11.9332 10.5613 11.8752 10.7112 11.8752 10.8666V15.2905C11.8752 15.3934 11.8498 15.4947 11.8013 15.5854C11.7527 15.6761 11.6825 15.7535 11.5969 15.8105L9.09693 17.4772C9.0028 17.54 8.89341 17.576 8.78042 17.5814C8.66743 17.5869 8.55507 17.5616 8.45533 17.5082C8.35559 17.4548 8.27221 17.3754 8.21408 17.2784C8.15594 17.1813 8.12524 17.0703 8.12524 16.9572V10.8666C8.12524 10.7112 8.06729 10.5613 7.9627 10.4462L2.82562 4.79542C2.74418 4.70583 2.6905 4.5945 2.67114 4.47498C2.65177 4.35546 2.66753 4.23288 2.71651 4.12215C2.7655 4.01142 2.84559 3.9173 2.94706 3.85124C3.04853 3.78517 3.167 3.75 3.28809 3.75V3.75Z",
    stroke: "#4F7D9C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueFunnel);
export default __webpack_public_path__ + "static/media/blueFunnel.aa91448840c3ad28b65e8d4d5f85f1a8.svg";
export { ForwardRef as ReactComponent };